import { InteractionType } from '@azure/msal-browser';
import { useMsal, useMsalAuthentication } from '@azure/msal-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { loginRequest } from '@/authConfig';
import LoadingModal from '@/components/LoadingModal';

// Login will be initiated from src/index.tsx. This page will only verify if the login was successful or not.
export default function SsoAzureLogin() {
  const navigate = useNavigate();

  const { error } = useMsalAuthentication(InteractionType.Redirect, loginRequest);

  useEffect(() => {
    if (error) {
      navigate('/login/failure');
    }
  }, [error, navigate]);

  // Get the accounts from the MSAL context
  const { accounts } = useMsal();

  useEffect(() => {
    if (accounts.length > 0) {
      navigate('/');
    }
  }, [accounts, navigate]);

  return <LoadingModal />;
}
